import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonUtil, LoginService, MessageService } from '@serengeti/serengeti-common';
import { map } from 'rxjs/operators';
import { MenuService } from '@serengeti/serengeti-menu';
import { environment } from 'src/environments/environment';
import { AuthServiceBase } from './auth.service.base';

@Injectable({
	providedIn: 'root'
})
export class AuthService extends AuthServiceBase {

	endPoint: string;

	constructor(
		private messageService: MessageService,
		protected router: Router,
		protected menuService: MenuService,
		protected loginService: LoginService,
		protected translateService: TranslateService
	) {
		super(router, menuService, loginService, translateService);

		this.endPoint = CommonUtil.buildEndPoint(environment.serviceMemberEndPoint, 'session');
	}

	getAuthSession(pageAble: any, search?: string) {
		const url = CommonUtil.buildEndPoint(this.endPoint, '/authSession');
		console.log(search);

		const params = new HttpParams()
			.set('page', pageAble.pageNumber)
			.set('size', pageAble.pageSize)
			.set('sortKeyword', pageAble.sortKeyword)
			.set('sortOrder', pageAble.sortOrder)
			.set('search', search);

		return this.messageService.query(url, params);
	}

}
